import useOpenBankingPaymentCard from './useOpenBankingPaymentCard';

import BasePaymentSelectDetails from '../BasePaymentSelectDetails';

const OpenBankingPaymentCard: React.FunctionComponent = function () {
  const { companyName, toPay } = useOpenBankingPaymentCard();
  return (
    <BasePaymentSelectDetails
      title={`Pay the full amount today, directly to ${companyName}`}
      points={[]}
      footerHeading={toPay}
      footerSubheading="One-time payment in full today"
    />
  );
};

export default OpenBankingPaymentCard;
